import React, { useState, useEffect } from "react";
import axios from "axios";

import { FetchAxiosGet } from "../../../api/axios";
import {
  Badge,
  Table,
  Col,
  Row,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  InputGroup,
  Input,
  Label,
  Spinner,
} from "reactstrap/";
import { GetCookieToken } from "../../Cookie/GetCookie";
import { Fragment } from "react";
import InsertData from "./InsertData";
import EditData from "./EditData";
import LoadingData from "../../TESTPage/LoadingData";
import LoadingPage from "../../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import SetDataloading from "../../TESTPage/SetDataloading";
import ConfirmModal from "../../../components/Common/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { CheckPosition } from "../../Function/CheckPosition";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";

const API_URL = process.env.REACT_APP_API_CORS;

function ViewData(props) {
  const {userInfo} = props
  const navigate = useNavigate();
  const [masterdata, setMasterdata] = useState([]);
  const [data, setData] = useState([]);
  const [dataInfo, setDataInfo] = useState([]);
  const token = GetCookieToken("userToken");

  const [keyword, setKeyword] = useState("");
  const [pushkeyword, setPushKeyword] = useState("");
  const [dataSelect, setDataSelect] = useState("ปกติ");
  const [dataSelectId, setDataSelectId] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalOrder, setTotalOrder] = useState(0);
  const [loading, setLoading] = useState(true);
  const [cp, setCP] = useState(0);

  const [inversedSort, setInversedSort] = useState(false);
  const [indexSort, setIndexSort] = useState(0);

  const [confirmModal, setconfirmModal] = useState(false)
  const [userID, setUserID] = useState()

  const fetchData = async (orderBy = "user_id", sortedBy = "ASC") => {
    setLoading(true);
    const url = `${API_URL}/api/users/datatable`;
    const params = new URLSearchParams({
      page: currentPage,
      size: pageSize,
      "order[0]": orderBy,
      "order[1]": sortedBy,
      "filter[user_name_status][0]": dataSelect,
      "filter[deleted][0]": "1",
      search: pushkeyword,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then((response) => {
        setData(() => response.data.result);
        setDataInfo(() => response.data.info);
        setTotalPages(Math.ceil(response.data.info.totalRows / pageSize));
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => console.error("Error:", error));
  };

  useEffect(() => {
    
    fetchData();

  }, [currentPage, dataSelect, pageSize, pushkeyword,]);

  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/users/config/all`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setMasterdata(response.data.result);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchMasterData();
  }, []);

  const handleSearch = () => {
    setPushKeyword(() => keyword);
  };

  const deleteState = (id) => {
    setData((prevData) => prevData.filter((item) => item.user_id !== id));
  };

  const fetchDeleteData = async (user_id) => {
    setLoading(true);
    try {
      const response = await axios.delete(`${API_URL}/api/users/${user_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const handleButtonClick = (value) => {
    // setLoading(true);
    // setTimeout(() => {
      fetchData();
    //   setLoading(false);
    // }, 1500);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const headers = [
    { field: "user_name", label: "ชื่อ-นามสกุล" },
    { field: "user_login", label: "บัญชีผู้ใช้" },
    { field: "user_intercom", label: "หมายเลขภายใน" }
  ];
  

  const handleHeaderClick = (value, index, inversed) => {
    setIndexSort(index)
    setInversedSort(inversed)
    fetchData(value, inversed ? "DESC" : "ASC")
  }

  const headerStyles = {
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    cursor: "pointer",
    transition: "background-color 0.3s",
  }
  
  const sortIcon = (index) => {
    return (
      <i className={`ps-2 ${indexSort === index ? `fa-duotone fa-sort-${inversedSort ? "down" : "up"}` : "text-secondary fa-regular fa-sort"}`}></i>
    );
  }

  const hoverEffect = (e, inOut) => {
    e.target.style.backgroundColor = inOut ? "rgba(215,218,222,0.6)" : "rgba(239,242,247,1)"
  }

  const handleModal = (toggle, userID) => {
    setconfirmModal(toggle)
    setUserID(userID)
  }

  // useEffect(() => {
  //     if (userInfo) {
  //       if (
  //         !CheckSubAdmin(userInfo?.positionSubAdmin) ||
  //         (CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && CheckSubAdmin(userInfo?.positionSubAdmin).includes(6) )
  //       ) 
  //       {
  //         navigate("/dashboard");
  //       }
  //     }
  // }, [userInfo]);

  return (
    <Fragment>
        <FadeIn>
          <Row className="mb-3">
            <Col lg={8}>
              <InputGroup>
                <Input
                  type="search"
                  value={keyword}
                  style={{ width: "40%" }}
                  placeholder="...กรุณาใส่คำที่ต้องการค้นหา"
                  onKeyDown={handleKeyDown}
                  onChange={(e) => setKeyword(e.target.value)}
                />
                <Input
                  value={dataSelectId}
                  name="user_id_status"
                  style={{ width: "15%" }}
                  type="select"
                  placeholder="...กรุณาใส่คำที่ต้องการค้นหา"
                  onChange={(e) => {
                    setDataSelect(
                      e.target.options[e.target.selectedIndex].text
                    );
                    setDataSelectId(e.target.value);
                  }}
                >
                  {masterdata.user_id_status?.map((masterdata, index) =>
                    masterdata.id !== 5 ? (
                      <option value={masterdata.id} key={index}>
                        {masterdata.name}
                      </option>
                    ) : null
                  )}
                </Input>
                <Button
                  style={{ display: "flex", alignItems: "center" }}
                  color="primary"
                  onClick={handleSearch}
                >
                  <i className="fa-sharp fa-solid fa-magnifying-glass fa-xl"></i>
                  {/* ค้นหาเจ้าหน้าที่ */}
                </Button>
              </InputGroup>
            </Col>
            <Col style={{ display: "flex", justifyContent: "end" }}>
              <InsertData onButtonClick={handleButtonClick} />
            </Col>
          </Row>
          <Row>
              <Table
                className="align-middle"
                striped
                style={{
                  // textAlign: "center",
                  overflow: "scroll",
                  fontSize: "15px"
                }}
                responsive
              >
                <thead className="table-light text-center" style={headerStyles}>
                  <tr>
                    <th style={{ width: "10px" }}>ลำดับ</th>
                    {headers.map((header, index) => (
                      <th key={index} onMouseEnter={(e) => hoverEffect(e, true)} onMouseLeave={(e) => hoverEffect(e, false)} onClick={() => handleHeaderClick(header.field, index, !inversedSort)}>
                      {header.label}{sortIcon(index)}
                    </th>
                    ))}
                    <th>{/* <i className="fa-solid fa-envelope"></i> */}</th>
                  </tr>
                </thead>
                {loading ?
                <tbody>
                  <tr>
                    <td colSpan={5}>
                      <LoadingData />
                    </td>
                  </tr>
                </tbody> :
                <tbody>
                  {data?.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center fs-5">
                        ไม่มีข้อมูล
                      </td>
                    </tr>
                  ) : (
                    data?.map((user, index) => {
                      let cp = (currentPage - 1) * 10;
                      let cp2 = (currentPage - 1) * 25;
                      let cp3 = (currentPage - 1) * 50;
                      return user.deleted === 1 ? (
                        <tr key={index}>
                          {pageSize === 10 || pageSize === "10" ? (
                            <td>{index + cp + 1}</td>
                          ) : (
                            ""
                          )}
                          {pageSize === "25" ? <td>{index + cp2 + 1}</td> : ""}
                          {pageSize === "50" ? <td>{index + cp3 + 1}</td> : ""}
                          <td className="text-nowrap">{user.user_name}</td>
                          <td className="text-nowrap text-center">{user.user_login}</td>
                          <td className="text-nowrap text-center">{user.user_intercom}</td>
                          <td>
                            <EditData
                              id={user.user_id}
                              onButtonClick={handleButtonClick}
                            />
                            <Button
                              className="mt-1"
                              color="danger"
                              onClick={() => {
                                handleModal(true, user.user_id)
                              }}
                            >
                              <i className="fa-solid fa-trash"></i>
                            </Button>
                            
                          </td>
                        </tr>
                      ) : (
                        ""
                      );
                    })
                  )}
                </tbody>
                }
               
              </Table>
              <Row
                  className="mx-2"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
              >
                <Col xxl={4}>
                  <h4 className="mb-0">
                    <Badge className="badge-soft-primary me-1 fs-5">
                      ทั้งหมด {dataInfo?.totalRows} รายการ
                    </Badge>
                  </h4>
                </Col>
                <Col xxl={8} className="d-flex justify-content-end">
                  <Pagination className="mt-3">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink onClick={() => setCurrentPage(1)}>
                        หน้าแรก
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink onClick={() => setCurrentPage(currentPage - 1)}>
                          ย้อนกลับ
                        </PaginationLink>
                    </PaginationItem>
                    <PaginationItem active>
                        <PaginationLink>หน้า {currentPage} จาก {totalPages}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem
                        disabled={
                          currentPage === dataInfo.totalPage ||
                          totalPages === 0
                        }
                      >
                        <PaginationLink
                          onClick={() =>
                            setCurrentPage(dataInfo.currentPage + 1)
                          }
                        >
                          ถัดไป
                        </PaginationLink>
                    </PaginationItem>
                    <PaginationItem
                        disabled={
                          currentPage === totalPages || totalPages === 0
                        }
                      >
                        <PaginationLink
                          onClick={() => setCurrentPage(dataInfo.totalPage)}
                        >
                          หน้าสุดท้าย
                        </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </Col>
              </Row>
          </Row>
              <ConfirmModal
                modal = {confirmModal}
                modalSize = "md"
                modalHeaderContent = "คุณต้องการที่จะลบ ใช่หรือไม่?"
                onClickConfirmBtn={() => {
                  fetchDeleteData(userID);
                  deleteState(userID);
                  setconfirmModal(false)
                }}
                onClickCancelBtn={() => {
                  setconfirmModal(false)
                }}
               />
        </FadeIn>
    </Fragment>
  );
}

export default ViewData;